import { actionTypesEnum } from '../enum';

export const getErrores = (state = null, action) => {

    if(action.type === actionTypesEnum.getErrores){
      return action.payload;
    }

     return state;
};

export const getNuevoDocumentoErrores = (state = null, action) => {

    if(action.type === actionTypesEnum.getNuevoDocumentoErrores){
      return action.payload;
    }

     return state;
};